module.exports = {"id":"171877","name":"Marek Hamšík","rating":"87","photo":"./data/images/photos/4/171877.png","club":{"name":"Naples","logo":"./data/images/clubs/Naples.png"},"positions":["MC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MarekHamsik0.json
// module id = 2767
// module chunks = 0